import React from 'react';
import { FileText, Download, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RentalResourcesCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-br from-purple-50 to-blue-50 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="bg-gradient-to-r from-purple-500 to-blue-500 p-3 rounded-lg mr-4">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800">
              Rental Resources
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Free templates and documents
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg p-6 mb-4 shadow-sm">
        <div className="flex items-start mb-3">
          <Download className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-1" />
          <div>
            <h4 className="font-semibold text-gray-800 mb-1">
              Rental Agreement Template
            </h4>
            <p className="text-sm text-gray-600">
              Download our professionally crafted rental agreement template,
              designed with Irish rental law in mind.
            </p>
          </div>
        </div>

        <ul className="space-y-2 ml-8 text-sm text-gray-700">
          <li className="flex items-center">
            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
            <span>Legally sound and comprehensive</span>
          </li>
          <li className="flex items-center">
            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
            <span>Easy to fill and customize</span>
          </li>
          <li className="flex items-center">
            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
            <span>Completely free to use</span>
          </li>
        </ul>
      </div>

      <button
        onClick={() =>
          navigate('/landlord-resources/rental-agreement-templates')
        }
        className="w-full flex items-center justify-center bg-gradient-to-r from-purple-500 to-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 font-semibold"
      >
        <span>Access Resources</span>
        <ArrowRight className="w-5 h-5 ml-2" />
      </button>

      <p className="text-xs text-gray-500 text-center mt-3">
        Includes legal disclaimers and professional guidance
      </p>
    </div>
  );
};

export default RentalResourcesCard;
